import styled, { keyframes, css } from 'styled-components'

const propbarFadeTransition = keyframes`
  0% {
    opacity: 1;
    z-index: 3;
  }

  27% {
    opacity: 1;
    z-index: 3;
  }

  33% {
    opacity: 0;
    z-index: 1;
  }

  94% {
    opacity: 0;
    z-index: 1;
  }

  100% {
    opacity: 1;
    z-index: 3;
  }
`

const Container = styled.div`
  height: 58px;
  position: relative;
  padding: 0;
`

const Slot = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  margin: 0;
  height: 58px;
  width: 100%;
  padding: 15px 0;
  background-color: ${(props) => props.theme.color_grey_light};
  position: absolute;
  top: 0;
  animation: ${propbarFadeTransition} 12s infinite;

  &:nth-child(1) {
    animation-delay: 0s;
    opacity: 1;
    z-index: 3;
  }

  &:nth-child(2) {
    animation-delay: 4s;
    opacity: 1;
    z-index: 2;
  }

  &:nth-child(3) {
    animation-delay: 8s;
    opacity: 1;
    z-index: 1;
  }

  &:focus {
    z-index: 4;
    opacity: 1;
    animation: none;
  }

  @media (min-width: ${(props) => props.theme.screen_lg_min}) {
    z-index: 1;
    opacity: 1;
    flex: 1 1 0px;
    position: relative;
    animation: none;

    &:nth-child(2) {
      margin: 0 10px;
    }
  }
`

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  svg {
    height: 30px;
    width: 35px;

    ${(props) =>
      css`
      ${props.fastTrackIcon &&
        css`
          &:nth-child(1) {
            height: 22px;
            width: 45px;
            margin-right: 8px;
          }
          &:nth-child(2) {
            fill: #494c4a;
            padding-right: 8px;
          }
        `}
        ${props.clickAndCollectIcon &&
          css`
            height: 27px;
            width: 59px;
            margin-top: 5px;
          `}
        ${props.paymentIcon &&
          css`
            fill: #494c4a;
            width: 30px;
          `}
      `}
  }
`

const TextBlock = styled.div`
  justify-content: center;
  align-self: stretch;
  margin-left: 8px;
  padding-left: 8px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  font-size: 0.75rem;
  border-left: 1px solid ${(props) => props.theme.color_grey_mid};

  p {
    line-height: normal;
    margin: 0;
  }
`

const Strong = styled.strong`
  ${(props) =>
    css`
      ${props.mauve
        ? css`
            color: ${props.theme.color_mauve};
          `
        : css`
            color: ${props.theme.color_grey_darker};
          `}
    `}
`

export { Container, Strong, Slot, IconWrapper, TextBlock }
